// Saring daftar menu sidebar berdasarkan kata kunci.
// Judul grup (CNavTitle) ikut tampil di atas hasilnya; mengetik nama grup menampilkan seluruh isinya.
export function cariMenu(items, kata) {
  const q = String(kata || '').trim().toLowerCase()
  if (!q) return items
  const cocok = (teks) => String(teks || '').toLowerCase().includes(q)
  const hasil = []
  let judul = null
  let judulCocok = false
  items.forEach((item) => {
    if (item.component === 'CNavTitle') {
      judul = item
      judulCocok = cocok(item.name)
      return
    }
    let tampil = null
    if (item.items) {
      const anak = judulCocok || cocok(item.name) ? item.items : cariMenu(item.items, q)
      if (anak.length) tampil = { ...item, items: anak }
    } else if (judulCocok || cocok(item.name)) {
      tampil = item
    }
    if (!tampil) return
    if (judul && !hasil.includes(judul)) hasil.push(judul)
    hasil.push(tampil)
  })
  return hasil
}
